// extracted by mini-css-extract-plugin
export var avatarContainer = "_7e-0";
export var avatarTypingWave = "_7e-i";
export var gray = "_7e-f";
export var green = "_7e-c";
export var icon = "_7e-9";
export var image = "_7e-1";
export var lg = "_7e-6";
export var md = "_7e-5";
export var presenceDot = "_7e-b";
export var red = "_7e-d";
export var sm = "_7e-4";
export var status = "_7e-a";
export var typingDot = "_7e-h";
export var typingPill = "_7e-g";
export var xl = "_7e-7";
export var xs = "_7e-3";
export var xxl = "_7e-8";
export var xxs = "_7e-2";
export var yellow = "_7e-e";